<template>
  <e-modal :visible="visible" title="上传资源管理" :width="1000" @close="onClose" :zIndex="zIndex">
    <template #footer>
      <div class="buttons">
        <div>
          <a-input v-model:value="queryParams.Name" placeholder="文件名" allowClear
            style="width: 150px; margin-right: 8px" />

          <a-date-picker v-model:value="createDate" placeholder="上传日期" />
          <a-button type="primary" @click="onSearch"> 搜索 </a-button>

          <a-button type="primary" @click="cropperImageRef.open()">
            <ScissorOutlined /> 裁剪上传
          </a-button>

          <a-upload name="file" :customRequest="uploads" multiple :beforeUpload="beforeUpload" :showUploadList="false"
            style="margin-right: 8px">
            <a-button type="primary">
              <UploadOutlined /> 文件上传
            </a-button>
          </a-upload>

          <a-button type="primary" @click="shotImageRef.open()">
            <ScissorOutlined /> 截图上传
          </a-button>
        </div>

        <div>
          <a-button type="primary" :disabled="choosed.length === 0" @click="onSubmit">
            选择
          </a-button>
          <a-button @click="onClose">关闭</a-button>
        </div>
      </div>
    </template>
    <div class="resource-body">
      <div class="right"
        :style="dataStore.resourceTotal > queryParams.Limit ? 'padding-bottom: 50px' : 'padding-bottom: 0'">
        <div class="rc-list">
          <a-spin tip="加载中..." :spinning="loading">
            <div class="list">
              <div v-for="(v, k) in list" :key="k" :class="{
                item: true,
                on: onCheckChoose(v.url),
              }" @click="onChoose(v.url)" @dblclick="onCropper(v)">
                <div class="li">
                  <div class="li-img">
                    <img v-if="v.ext.indexOf('jpg') !== -1" :src="v.url" :alt="v.name" />
                    <img v-if="v.ext.indexOf('png') !== -1" :src="v.url" :alt="v.name" />
                    <img v-if="v.ext.indexOf('gif') !== -1" :src="v.url" :alt="v.name" />
                    <img v-if="v.ext.indexOf('jfif') !== -1" :src="v.url" :alt="v.name" />
                    <img v-if="v.ext.indexOf('video') !== -1" src="~@/assets/video.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('wav') !== -1" src="~@/assets/audio.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('mp3') !== -1" src="~@/assets/audio.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('mp4') !== -1" src="~@/assets/video.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('wmv') !== -1" src="~@/assets/video.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('avi') !== -1" src="~@/assets/video.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('doc') !== -1" src="~@/assets/file.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('pdf') !== -1" src="~@/assets/file.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('xls') !== -1" src="~@/assets/file.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('ppt') !== -1" src="~@/assets/file.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('txt') !== -1" src="~@/assets/file.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('zip') !== -1" src="~@/assets/zip.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('rar') !== -1" src="~@/assets/zip.png" :alt="v.name" />
                    <img v-if="v.ext.indexOf('7z') !== -1" src="~@/assets/zip.png" :alt="v.name" />
                  </div>
                  <div class="li-title">{{ v.name }}</div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>

        <div class="page" v-if="dataStore.resourceTotal > queryParams.Limit">
          <a-pagination :total="dataStore.resourceTotal" v-model:page-size="queryParams.Limit"
            :hide-on-single-page="true" :show-size-changer="true" :page-size-options="['20', '80', '200', '500']"
            @change="changePage" @showSizeChange="onShowSizeChange">
            <template #itemRender="{ page, type }">
              <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
              <a v-else-if="type === 'next'" class="ant-pagination-item-link">
                下一页
              </a>
              <span v-else>{{ page }}</span>
            </template>
          </a-pagination>
        </div>
      </div>
    </div>

    <CropperImage ref="cropperImageRef" @ok="uploadCropImage" />
    <ShotImage ref="shotImageRef" @ok="uploadCropImage" />
  </e-modal>
</template>

<script lang="ts" setup>
import { reactive, ref, toRaw, toRefs } from 'vue'
import CropperImage from './CropperImage.vue'
import ShotImage from './ShotImage.vue'
import { QueryResourceArgs } from '@/models/args'
import { ResourceDto } from '@/models/dtos'
import { useAppStore, useDataStore, useUserStore } from '@/store'
import { message } from 'ant-design-vue'
import { ScissorOutlined, UploadOutlined } from '@ant-design/icons-vue'
import { ResourceChoosedType } from '@/models/types'

const dataStore = useDataStore()
const appStore = useAppStore()
const userStore = useUserStore()
const loading = ref(false)
const visible = ref(false)
const limitImage = ref(0)
const originalField = ref('')
const callbackFun = ref()
const list = ref<ResourceDto[]>([])
const choosed = ref<string[]>([])
const fileCount = ref(0)
const uploadFileList = ref<string[]>([])
const createDate = ref()
const cropperImageRef = ref()
const shotImageRef = ref()
const queryParams = reactive<QueryResourceArgs>({
  Type: 0,
  Limit: 36,
  Offset: 0
})

// eslint-disable-next-line no-undef
const props = defineProps({
  zIndex: {
    type: Number,
    default: 99996
  }
})

const { zIndex } = toRefs(props)

const onOpen = (limit = 0, field = '', callback = null) => {
  limitImage.value = limit
  originalField.value = field
  callbackFun.value = callback

  const user = userStore.userInfo
  if (!user?.roleIds.includes(1)) {
    queryParams.UserId = user?.id
  }

  getDataList()
  visible.value = true
}

const onClose = () => {
  choosed.value = []
  visible.value = false
}

const onSearch = () => {
  queryParams.Offset = 0
  getDataList()
}

const getDataList = () => {
  loading.value = true
  const q = { ...toRaw(queryParams) }

  if (createDate.value) {
    q.Date = createDate.value.format('YYYY-MM-DD')
  }

  dataStore.getResourceList(q).then(resp => {
    list.value = resp

    loading.value = false
  })
}

const changePage = (page: number) => {
  queryParams.Offset = (page - 1) * (queryParams.Limit as number)
  getDataList()
}

const onShowSizeChange = (current: number, size: number) => {
  queryParams.Limit = size
}

const onChoose = (image) => {
  const s = new Set(choosed.value)
  if (s.has(image)) {
    s.delete(image)
  } else {
    s.add(image)
  }
  choosed.value = Array.from(s)
}

const onCheckChoose = (image: string) => {
  return choosed.value.includes(image)
}

const uploadCropImage = (e) => {
  dataStore.createResource(e).then(() => {
    cropperImageRef.value.onClose()
    shotImageRef.value.onClose()

    queryParams.Offset = 0
    getDataList()
  })
}

const onCropper = (res: ResourceDto) => {
  console.log(res)
}

const beforeUpload = (file, fileList) => {
  fileCount.value = fileList.length
}

const uploads = (e) => {
  loading.value = true
  const formData = new FormData()
  formData.append('file', e.file, e.file.name)

  dataStore.createResource(formData).then(resp => {
    uploadFileList.value.push(resp.url)

    if (uploadFileList.value.length >= fileCount.value) {
      uploadFileList.value = []
      fileCount.value = 0
      queryParams.Offset = 0
      getDataList()
    }
  })
}

// eslint-disable-next-line no-undef
const emit = defineEmits(['ok'])

const onSubmit = () => {
  if (limitImage.value > 0 && limitImage.value < choosed.value.length) {
    message.error(`最多选择${limitImage.value}个文件`)
    return false
  }

  emit('ok', {
    images: toRaw(choosed.value),
    field: originalField.value,
    callback: callbackFun.value
  } as ResourceChoosedType)

  onClose()
}

// eslint-disable-next-line no-undef
defineExpose({
  onOpen
})
</script>

<style lang="less" scoped>
.resource-body {
  position: relative;
  width: 100%;
  height: 570px;
  box-sizing: border-box;
  overflow: auto;

  .right {
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 50px;
    box-sizing: border-box;

    .rc-list {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;

      .list {
        width: 960px;
        display: flex;
        flex-wrap: wrap;

        .item {
          padding: 5px;
          box-sizing: border-box;
          width: 160px;
          cursor: pointer;

          .li {
            border: 1px solid transparent;
            padding: 5px;
            box-sizing: border-box;

            .li-img {
              display: flex;
              justify-content: center;
              align-items: flex-end;
              width: 100%;
              height: 114px;

              img {
                display: block;
                max-width: 100%;
                max-height: 100%;
              }
            }

            .li-title {
              font-size: 12px;
              line-height: 24px;
              text-align: center;
              overflow: hidden;
              height: 24px;
            }
          }

          &:hover {
            .li {
              border-color: #7e70ff;
              background: url(../../assets/drag-bg-1.png);
            }
          }

          &.on {
            .li {
              border-color: #4c38ff;
              background: url(../../assets/drag-bg.png);
            }
          }
        }
      }
    }

    .page {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
    }
  }
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 14px;

  button {
    margin: 0 5px;
  }
}
</style>